"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var bindTrailingArgs = exports.bindTrailingArgs = function bindTrailingArgs(func) {
  for (var _len = arguments.length, boundArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    boundArgs[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return func.apply(undefined, args.concat(boundArgs));
  };
};

var chunkify = exports.chunkify = function chunkify(array, chunks, balanced) {

  if (chunks < 2) return [array];

  var len = array.length;
  var result = [];
  var i = 0;
  var size = void 0;

  if (len % chunks === 0) {
    size = Math.floor(len / chunks);
    while (i < len) {
      result.push(array.slice(i, i += size));
    }
  } else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / chunks--);
      result.push(array.slice(i, i += size));
    }
  } else {
    chunks--;
    size = Math.floor(len / chunks);
    if (len % size === 0) size--;
    while (i < size * chunks) {
      result.push(array.slice(i, i += size));
    }
    result.push(array.slice(size * chunks));
  }

  return result;
};

var sortByProp = exports.sortByProp = function sortByProp(prop, x, y) {
  var result = 0;
  if (x[prop] < y[prop]) {
    result = -1;
  } else if (x[prop] > y[prop]) {
    result = 1;
  } else {
    result = 0;
  }
  return result;
};

var sortByProps = exports.sortByProps = function sortByProps(prop1, prop2, x, y) {
  var result = 0;
  if (x[prop1] < y[prop1]) {
    result = -1;
  } else if (x[prop1] > y[prop1] || x[prop1] === y[prop1] && x[prop2] > y[prop2]) {
    result = 1;
  } else {
    result = 0;
  }
  return result;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/util.js
 ** module id = 514
 ** module chunks = 0
 **/